<template>
  <div>
    <div class="container-fluid">
      <div class="top-nav">
        <nav class="navbar navbar-expand-lg navbar-light" aria-label="Menu główne">
          <div class="container-fluid">
            <a class="navbar-brand" href="/" style="max-width:40%">
              <div src="/images/logo.svg" class="d-block d-md-inline-block img-fluid" alt="PKP INTERCITY LOGO" id="pkp-ic-logo"></div>
            </a>
            <div class="d-block d-lg-none ms-auto">

              <button type="button" data-bs-toggle="dropdown" id="login-selector1" aria-expanded="false"
                aria-label="Wybierz sposób logowania" class="btn btn-ghost dropdown-toggle"><i
                  class="bi bi-person-fill"></i></button>
              <ul class="dropdown-menu rounded-1 dropdown-menu-end" aria-labelledby="login-selector1">
                <li class="">
                  <a class="dropdown-item" target="_blank" href="https://ebilet.intercity.pl/profil"
                    role="button">{{ $t('ic_aside_moje_konto') }} <span class="sr-only">Zaloguj się do swojego konta w
                      systemie eIC - otwiera się w nowej karcie</span></a>

                </li>
                <li class="">
                  <a class="dropdown-item" target="_blank" href="https://ebilet.intercity.pl/profil/loginkontogosc"
                    role="button">{{ $t('ic_aside_uzytkownicy_niezarejestrowani') }} <span class="sr-only">przejdź do
                      konta gość w systemie eIC - otwiera się w nowej karcie</span></a>
                </li>
              </ul>
            </div>

            <button class="navbar-toggler" type="button" data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false"
              aria-label="Menu">

              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse mega-menu mt-2 mt-lg-auto" id="navbarSupportedContent">
              <ul class="navbar-nav ms-auto">
                <li :class="{ 'nav-item': true, 'dropdown position-static': item.items && item.items.length }" v-for="(item, index) in items" :key="index">
                  <a :href="item.url" :class="{ 'nav-link': true, 'dropdown-toggle': item.items && item.items.length }"
                    role="button" data-bs-toggle="dropdown" aria-expanded="false" :id="'navbarDropdown' + index">{{
                    item.label }}</a>
                  <div v-if="item.items && item.items.length" class="dropdown-menu top-auto"
                    :aria-labelledby="'navbarDropdown' + index">

                    <div class="container">
                      <ul class="row row-cols-1 row-cols-xl-5 row-cols-md-3 list-unstyled text-small my-2">
                        <li v-for="(submenu, index2) in item.items" :key="index2">
                          <a :href="submenu.url" :title="submenu.label" :tabindex_="index + index2"
                            class="dropdown-item-text"><span class="mtm mbm">{{ submenu.label }}</span></a>
                          <ul class="list-unstyled" v-if="submenu.items">
                            <li class="" v-for="(i, ind) in submenu.items" :key="ind">
                              <a :href="i.url" :title="i.label" :tabindex_="ind" class="dropdown-item">{{ i.label }}</a>
                            </li>
                          </ul>
                        </li>
                      </ul>

                    </div>
                  </div>
                </li>

              </ul>
              <div class="top-utils d-flex align-items-center">
                <div class="vr mx-3"></div>
                <a class="btn btn-ghost page-header__ue-dla-pkp d-none d-md-inline-block"
                  href="site/o-nas/o-firmie/ue-dla-pkp-ic/"><span class="sr-only">Informacje na temat wykorzystania
                    środków z Unii Europejskie w PKP Intercity</span></a>

                <a class="btn btn-ghost"
                  href="/pl/site/dla-pasazera/informacje-dla-osob-z-niepelnosprawnoscia-i-osob-o-ograniczonej-sprawnosci-ruchowej/"><span
                    class="img-icon img-icon--wheelchair"></span><span class="sr-only tooltip">Informacje dla osób z
                    niepełnosprawnością
                    i osób o ograniczonej sprawności ruchowej</span></a>

                <a class="btn btn-ghost" href="https://pzgomaz.com/notLogged?customer=PKP_Intercity" target="_blank"
                  title="Tłumacz języka migowego"><span class="img-icon img-icon--migam"></span></a>

                <button type="button" :aria-label="changeThemeButtonLabel" class="contrast-selector btn btn-ghost"
                  @click.prevent="switchTheme"><i class="bi bi-circle-half"></i></button>




                <div class="btn font-size-changer no-wrap align-self-center">
                  <span class="font-size-xs" :class="{ 'fw-bold': currentSize == 's' }"
                    @click.prevent="fontSizeChangerHandleClick('s')"
                    aria-label="ustaw standardową wielkość czcionki">A</span>
                  <span class="font-size-sm" :class="{ 'fw-bold': currentSize == 'm' }"
                    @click.prevent="fontSizeChangerHandleClick('m')"
                    aria-label="ustaw większą wielkość czcionki">A</span>
                  <span class="font-size-md" :class="{ 'fw-bold': currentSize == 'l' }"
                    @click.prevent="fontSizeChangerHandleClick('l')"
                    aria-label="ustaw największą wielkość czcionki">A</span>
                </div>



                <div class="dropdown">
                  <button type="button" class="btn btn-ghost dropdown-toggle rounded-1" data-bs-toggle="dropdown"
                    aria-expanded="false" id="language-selector"><img
                      :src="'images/icons/' + current.toUpperCase() + '.svg'" alt="" class="img-icon">
                    {{ current.toUpperCase() }}
                    <span class="sr-only" lang="en">change language</span>
                    <span class="sr-only" lang="ru">изменить язык</span>
                    <span class="sr-only" lang="pl">zmień język</span>
                  </button>
                  <ul class="dropdown-menu rounded-1" aria-labelledby="language-selector">
                    <li v-for="(item, index) in langs" :key="index">
                      <a class="dropdown-item" :href="item.lang"><img :src="'images/icons/' + item.name + '.svg'" alt=""
                          class="img-icon"> {{ item.name }} <span class="sr-only">zmień język na {{ item.full }}</span></a>
                    </li>
                  </ul>
                </div>
                <div class="vr"></div>
                <div class="dropdown">
                  <button type="button" class="d-none d-lg-inline  btn btn-ghost dropdown-toggle rounded-1"
                    data-bs-toggle="dropdown" id="login-selector" aria-expanded="false"
                    aria-label="Wybierz sposób logowania">
                    <img src="images/icons/user.svg" alt="" class="img-icon"> <span
                      class="d-none d-md-inline-block">{{ $t('ic_aside_logowanie_i_rejestracja') }}</span>
                  </button>
                  <ul class="dropdown-menu rounded-1 dropdown-menu-end" aria-labelledby="login-selector">
                    <li class="">
                      <a class="dropdown-item" target="_blank"
                        href="https://ebilet.intercity.pl/profil">{{ $t('ic_aside_moje_konto') }} <span
                          class="sr-only">Zaloguj się do swojego konta w systemie eIC - otwiera się w nowej
                          karcie</span></a>

                    </li>
                    <li class="">
                      <a class="dropdown-item" target="_blank"
                        href="https://ebilet.intercity.pl/profil/loginkontogosc">{{ $t('ic_aside_uzytkownicy_niezarejestrowani') }}
                        <span class="sr-only">przejdź do konta gość w systemie eIC - otwiera się w nowej
                          karcie</span></a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>
          </div>
        </nav>
      </div>
    </div>
    <img src="/images/train_bg.svg" alt="" class="top-image" v-if="showbgimage !== 0">
  </div>
</template>
<script>


import { thisExpression } from "@babel/types";
import search from "./../components/forms/inputs/search";

var Cookies = {};
Cookies.set = function (cname, cvalue, exdays) {
  const d = new Date();
  if (!exdays) exdays = 365;
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var exp = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + exp + ";path=/";
}

Cookies.get = function (cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}


export default {
  name: 'top-menu',
  components: { search },
  props: {
    showbgimage: 1
  },
  data() {
    return {
      currentTheme: Cookies.get('theme') ? Cookies.get('theme') : 'light',
      currentSize: Cookies.get('fontSize') ? Cookies.get('fontSize') : 's',
      changeThemeButtonLabel: 'Wersja kontrastowa',
      items: window.menu,
      langs: window.langs,
      current: window.selected?window.selected:"PL"
    }
  },
  methods: {
    darkTheme() {
      Cookies.set('theme', 'dark');
      let ThemeLinkEl = document.querySelector("#theme-style");

      //let parentNode = ThemeLinkEl.parentNode;
      //parentNode.removeChild(ThemeLinkEl);

      //let ThemeLinkEl = document.createElement("link");
      ThemeLinkEl.setAttribute("rel", "stylesheet");
      ThemeLinkEl.setAttribute("href", "/styles/app-dark.css?v=" + new Date());
      ThemeLinkEl.setAttribute("id", "theme-style");

      //let docHead = document.querySelector("head");
      //docHead.append(ThemeLinkEl);

      this.changeThemeButtonLabel = 'Wersja graficzna';

      let logo = document.querySelector("#pkp-ic-logo");
      logo.src = "/images/logo-kontrast.svg";
    },

    lightTheme() {
      Cookies.set('theme', 'light');
      let ThemeLinkEl = document.querySelector("#theme-style");
      //let parentNode = ThemeLinkEl.parentNode;
      //parentNode.removeChild(ThemeLinkEl);

      //let ThemeLinkEl = document.createElement("link");
      ThemeLinkEl.setAttribute("rel", "stylesheet");
      ThemeLinkEl.setAttribute("href", "/styles/app-light.css?v=" + new Date());
      ThemeLinkEl.setAttribute("id", "theme-style");
      window.resize();
      //let docHead = document.querySelector("head");
      //docHead.append(ThemeLinkEl);

      this.changeThemeButtonLabel = 'Wersja kontrastowa';
      let logo = document.querySelector("#pkp-ic-logo");
      logo.src = "/images/logo.svg";
    },
    switchTheme() {
      if (this.currentTheme === 'light') {
        this.currentTheme = 'dark';
        this.darkTheme();
      } else {
        this.currentTheme = 'light';
        this.lightTheme();
      }
    },
    fontSizeChangerHandleClick(size) {
      Cookies.set('fontSize', size);
      this.currentSize = size;
      let fontSize = 16;

      if (size === 'm')
        fontSize = 17;
      if (size === 'l')
        fontSize = 18;


      document.documentElement.style.fontSize = fontSize + "px";
    }
  },
  mounted: function () {
    if (this.items)
      for (let i = 0; i < this.items.length; i++) {
        var myDropdown = document.getElementById('navbarDropdown' + i)
        myDropdown.addEventListener('hidden.bs.dropdown', function () {
          this.focus();
        })
      }
    var myDropdown1 = document.getElementById('login-selector1')
    if(myDropdown1)
        myDropdown1.addEventListener('hidden.bs.dropdown', function () {
      //console.log(this);
      this.focus();
    })
    var myDropdown2 = document.getElementById('login-selector')
    myDropdown2.addEventListener('hidden.bs.dropdown', function () {
      //console.log(this);
      this.focus();
    })
    var myDropdown3 = document.getElementById('language-selector')
    myDropdown3.addEventListener('hidden.bs.dropdown', function () {
      //console.log(this);
      this.focus();
    })

  },
  created: function () {
    if (this.currentTheme != 'light') {
      this.darkTheme();
    }
    let fontSize = 16;
    if (this.currentSize === 'm')
      fontSize = 17;
    if (this.currentSize === 'l')
      fontSize = 18;
    document.documentElement.style.fontSize = fontSize + "px";

  }
}
</script>